import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './SearchBar.css';

export default function SearchBar() {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/search?q=${encodeURIComponent(query)}`);
    }
  };

  return (
    <div className="search-container">
      <div className="search-top-bar">
        <form onSubmit={handleSubmit} className="search-form">
          <div className="search-unit">
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search Products"
              className="search-bar"
              aria-label="Search products"
              enterKeyHint="search"
            />
          </div>
          <button type="submit" className="search-button">Search</button>
        </form>
      </div>
    </div>
  );
}
